import ChatBot from "@components/molecules/ChatBot";
import styles from "./CustomCardAndChatBot.module.scss";
import CardListV2 from "@components/molecules/CardListPrice/CardListV2";
import ChatbotSupport from "@components/molecules/ChatbotSupport";
import assetLoader from "@utils/internalImageLoder";
import { PageType } from "@constants/pageTypes";
import { type V2PriceBreakupResponse } from "@helpers/customCardHelper";

export default function CustomCardAndChatBotV2({
  variants,
  isLoggedIn,
  city,
  carName,
  brandName,
  modelName,
  isSellable,
  pageType,
  carAvailability,
  savingBalance,
  initialPriceBreakupsBySlug,
}: {
  variants: any[];
  isLoggedIn: boolean;
  city: any;
  carName?: string;
  brandName: string;
  modelName: string;
  isSellable: boolean;
  pageType?: PageType;
  carAvailability?: string;
  savingBalance?: any;
  initialPriceBreakupsBySlug?: Record<string, V2PriceBreakupResponse | null>;
}) {
  return (
    <div className={styles.container}>
      <CardListV2
        variants={variants}
        isLoggedIn={isLoggedIn}
        city={city}
        brandName={brandName}
        modelName={modelName}
        isSellable={isSellable}
        pageType={pageType}
        carAvailability={carAvailability}
        savingBalance={savingBalance}
        initialPriceBreakupsBySlug={initialPriceBreakupsBySlug}
      />
      <div className={styles.chatWrapper}>
        <ChatbotSupport
          heading="Not sure which variant suits you?"
          subheading="No worries, we'll help you with your question"
          buttonText="Find the right variant"
          icon={`/icons/chatbot.svg`}
          cityName={city.name}
          customChatbotStyling={styles.customChatbotStyling}
          chatBotPrompt={`Which variant should I buy in ${carName}?`}
          pageType={pageType}
          carAvailability={carAvailability}
          brandName={brandName}
          modelName={modelName}
        />
      </div>
    </div>
  );
}
